module.exports = __webpack_public_path__ + "img/2.07fa3056.png";